import Cookies from 'js-cookie';

export default function GlobalPopupCookies() {
    cookieCheck();
    cookieHandlers();
}

function cookieCheck() {
    if (!Cookies.get('newsletter-cookie')) {
        const newsletterPop = document.querySelector('.newsletter-popup');
        if (newsletterPop) {
            newsletterPop.classList.add('open');
            document.body.classList.add("stop-scrolling");
            Cookies.set('newsletter-cookie', true, {expires: 30});

        }
    }
}

function cookieHandlers() {
    const newsletterPop = document.querySelector('.newsletter-popup');
    if (newsletterPop) {
        let newsletterClose = newsletterPop.querySelector('.close');
        newsletterClose.addEventListener('click', function () {
            Cookies.set('newsletter-cookie', true);
            newsletterPop.classList.remove('open');
            document.body.classList.remove("stop-scrolling");
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    var updateCookieLink = document.getElementById('update-cookie-link');
    if (updateCookieLink) {
        updateCookieLink.addEventListener('click', function (e) {
            e.preventDefault();
            if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
                window.Cookiebot.renew();
            }

            // Use MutationObserver to wait for the settings and cookie-text elements to appear
            var observer = new MutationObserver(function(mutations, obs) {
                var settingsPopUp = document.getElementById("settings");
                var cookieText = document.getElementById("cookie-text");
                var cookieBack = document.getElementById("setting-back");
                if (settingsPopUp && cookieText) {
                    settingsPopUp.classList.add('show');
                    cookieText.style.display = "none";
                    if (cookieBack) {
                        cookieBack.onclick = function () {
                            settingsPopUp.classList.remove('show');
                            cookieText.style.display = "flex";
                        };
                    }
                    obs.disconnect(); // Stop observing once found and logic applied
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        });
    }
});